/**
 * Grenzen voor de weging (punten) van een taak uit de takencatalogus.
 *
 * Eén bron voor backend-validatie en het invoerveld in het beheerscherm; die
 * twee moeten gelijk lopen, anders accepteert het ene wat het andere weigert.
 *
 * De bovengrens ging in juli 2026 van 6 naar 40 voor het generieke functiehuis,
 * waarin het zwaarste domein (teamleiderschap) 30 punten weegt. De marge tot 40
 * is bewust: die maakt een laag boven de teamleiders mogelijk zonder opnieuw een
 * codewijziging.
 *
 * LET OP — dit is NIET `functionTasks.weging`, de functie-taak-weging die als
 * percentage tot 100 optelt. Ander veld, andere semantiek.
 */
export const TASK_WEGING_MIN = 1;
export const TASK_WEGING_MAX = 40;
//# sourceMappingURL=taskWeging.js.map